// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607222034/js/" + chunkId + "." + {"44":"7a63e15f","225":"9eeef5d5","481":"87d385d4","486":"550439a8","770":"e64ba67a"}[chunkId] + ".0.8048194951397946.chunk.js";
};